import { render, staticRenderFns } from "./HonorBanner.vue?vue&type=template&id=784a5dab&scoped=true&"
import script from "./HonorBanner.vue?vue&type=script&lang=js&"
export * from "./HonorBanner.vue?vue&type=script&lang=js&"
import style0 from "./HonorBanner.vue?vue&type=style&index=0&id=784a5dab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a5dab",
  null
  
)

export default component.exports